import React from "react";
import "./footer.css"; // Importing the CSS file


function Footer() {
  return (
    <footer className="footer">

    </footer>
  );
}

export default Footer;
